import { render, staticRenderFns } from "./rightCenter.vue?vue&type=template&id=23440910"
import script from "./rightCenter.vue?vue&type=script&lang=js"
export * from "./rightCenter.vue?vue&type=script&lang=js"
import style0 from "./rightCenter.vue?vue&type=style&index=0&id=23440910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports